var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('font-awesome-icon',{staticClass:"fa-spin",class:[_vm.fontSize, _vm.color],attrs:{"icon":"fa-solid fa-spinner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }